<h6>{{ dictionaryService.get('userCategoriesTitle') }}</h6>
<p>
  {{ dictionaryService.get('userCategoriesInstructions') }}
</p>
<strong> {{ dictionaryService.get('userCategoriesNote') }} </strong>
<div class="img-wrapper">
  <img class="icon" src="./assets/UploadUsersExample.png" />
</div>

<div class="buttons-wrapper">
  <button
    [buttonTheme]="'primary'"
    [buttonType]="'regular'"
    (click)="fileInput.click()"
  >
    <ng-icon name="CloudUpload" size="18" color="white"></ng-icon>
    {{ dictionaryService.get('UploadFile') }}
  </button>
  <input
    type="file"
    class="file-input"
    (change)="onFileChange($event)"
    #fileInput
    style="display: none"
  />

  <button
    [buttonTheme]="'light'"
    [buttonType]="'regular'"
    (click)="downloadTemplate()"
  >
    {{ dictionaryService.get('DownloadTemplate') }}
  </button>
</div>
